"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Sat Oct 13 2018
 */

var AdtFlag_1 = require("../../core/model/AdtFlag");
/**
 * Competitor reference price related to {@link CRPDTO}.
 * This flags marking state of competitor reference price.
 *
 * @author RV
 */
// tslint:disable:max-classes-per-file


var CRPFlag =
/*#__PURE__*/
function (_AdtFlag_1$AdtFlag) {
  _inherits(CRPFlag, _AdtFlag_1$AdtFlag);

  function CRPFlag() {
    _classCallCheck(this, CRPFlag);

    return _possibleConstructorReturn(this, _getPrototypeOf(CRPFlag).apply(this, arguments));
  }

  _createClass(CRPFlag, null, [{
    key: "register",
    value: function register(ctor, tag) {
      return AdtFlag_1.AdtFlag.registerBase(CRPFlag, ctor, tag);
    }
  }, {
    key: "deserialize",
    value: function deserialize(data) {
      return AdtFlag_1.AdtFlag.deserializeBase(CRPFlag, data);
    }
  }]);

  return CRPFlag;
}(AdtFlag_1.AdtFlag);

exports.CRPFlag = CRPFlag;
CRPFlag.TAG = '__CRPFlag__';
/**
 * Marks that a new competitor reference price is considerably higher than an actual regular price.
 */
// export class TooHighCompetitorPrice extends CRPFlag {
//     public static readonly TAG = CRPFlag.register(TooHighCompetitorPrice);
//     public validate(): boolean {
//         return true;
//     }
// }

/**
 * Marks that a new competitor reference price is considerably lower than an actual regular price.
 */
// export class TooLowCompetitorPrice extends CRPFlag {
//     public static readonly TAG = CRPFlag.register(TooLowCompetitorPrice);
//     public validate(): boolean {
//         return true;
//     }
// }

/**
 * Marks that a new competitor reference price is considerably higher than an actual competitor reference price.
 */
// export class TooHighCRPChange extends CRPFlag {
//     public static readonly TAG = CRPFlag.register(TooHighCRPChange);
//     public validate(): boolean {
//         return true;
//     }
// }

/**
 * Marks that a new competitor reference price is considerably lower than an actual competitor reference price.
 */
// export class TooLowCRPChange extends CRPFlag {
//     public static readonly TAG = CRPFlag.register(TooLowCRPChange);
//     public validate(): boolean {
//         return true;
//     }
// }

/**
 * Flag for mark competitor price, which is lower than purchase price of internal product.
 */

var NewCRPLowerThanPurchasePrice =
/*#__PURE__*/
function (_CRPFlag) {
  _inherits(NewCRPLowerThanPurchasePrice, _CRPFlag);

  function NewCRPLowerThanPurchasePrice() {
    _classCallCheck(this, NewCRPLowerThanPurchasePrice);

    return _possibleConstructorReturn(this, _getPrototypeOf(NewCRPLowerThanPurchasePrice).apply(this, arguments));
  }

  _createClass(NewCRPLowerThanPurchasePrice, [{
    key: "validate",
    value: function validate() {
      return true;
    }
  }]);

  return NewCRPLowerThanPurchasePrice;
}(CRPFlag);

exports.NewCRPLowerThanPurchasePrice = NewCRPLowerThanPurchasePrice;
NewCRPLowerThanPurchasePrice.TAG = CRPFlag.register(NewCRPLowerThanPurchasePrice);
/**
 * Marks that a competitor reference price was calculated from competitor prices marked with TooManyOutliers flag.
 */

var CRPTooManyOutliers =
/*#__PURE__*/
function (_CRPFlag2) {
  _inherits(CRPTooManyOutliers, _CRPFlag2);

  function CRPTooManyOutliers() {
    _classCallCheck(this, CRPTooManyOutliers);

    return _possibleConstructorReturn(this, _getPrototypeOf(CRPTooManyOutliers).apply(this, arguments));
  }

  _createClass(CRPTooManyOutliers, [{
    key: "validate",
    value: function validate() {
      return true;
    }
  }]);

  return CRPTooManyOutliers;
}(CRPFlag);

exports.CRPTooManyOutliers = CRPTooManyOutliers;
CRPTooManyOutliers.TAG = CRPFlag.register(CRPTooManyOutliers);
/**
 * Marks that a competitor reference price was calculated from competitor prices marked with TooManyPromos flag.
 */

var CRPTooManyPromos =
/*#__PURE__*/
function (_CRPFlag3) {
  _inherits(CRPTooManyPromos, _CRPFlag3);

  function CRPTooManyPromos() {
    _classCallCheck(this, CRPTooManyPromos);

    return _possibleConstructorReturn(this, _getPrototypeOf(CRPTooManyPromos).apply(this, arguments));
  }

  _createClass(CRPTooManyPromos, [{
    key: "validate",
    value: function validate() {
      return true;
    }
  }]);

  return CRPTooManyPromos;
}(CRPFlag);

exports.CRPTooManyPromos = CRPTooManyPromos;
CRPTooManyPromos.TAG = CRPFlag.register(CRPTooManyPromos);